import COLORS from '../../utils/constants/colors'

const cmsAdminPageStyles = {
  root: {
    overflow: 'auto',
    flexGrow: 1,
    marginLeft: '20px',
    marginRight: '20px',
  },
  appbar: {
    backgroundColor: 'transparent',
  },
  indicator: {
    color: COLORS.subscriptionBlue,
  },
  filtersContainer: {
    display: 'flex',
    gap: '16px',
    padding: '20px 24px',
    justifyContent: 'space-between',
    alignItems: 'center',
    minWidth: 0,
  },
  filtersRight: {
    display: 'flex',
    gap: '16px',
    alignItems: 'center',
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    flex: 1,
    minWidth: 0,
  },
  filterItem: {
    minWidth: '200px',
  },
}

export default cmsAdminPageStyles
